import type { TabularTreeNodeProps } from './TabularTreeNode'
import { TabularTreeNode } from './TabularTreeNode'
import map from 'lodash/map'
import React from 'react'

export type RenderChildrenRowsProps<T> = Omit<TabularTreeNodeProps<T>, 'index' | 'item'>

export function RenderChildrenRows<T>({ items, ...props }: RenderChildrenRowsProps<T>) {
  return map(items, (item, index) => (
    <TabularTreeNode {...props} items={items} item={item} index={index} key={item['_id'] ?? index} />
  ))
}
